import { module } from 'modujs';
import { queryClosestParent } from '../utils/html';
import { loadImage } from '../utils/image';
import { removeStyle } from '../utils/remove-style';

const PORTRAIT_WIDTH = "600"
const PORTRAIT_HEIGHT = "900"
const LANDSCAPE_WIDTH = "1360"
const LANDSCAPE_HEIGHT = "730"

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // First and last item
        const $wysiwygContainer = this.$('content')[0]
        if ($wysiwygContainer) {
            if ($wysiwygContainer.children.length) {
                const $firstElement = $wysiwygContainer.children[0]
                $firstElement.classList.add('c-wysiwyg-first-element')
            }
        }

        // Styles
        const $stylizedElements = this.el.querySelectorAll('[style]')
        if ($stylizedElements.length) {
            removeStyle($stylizedElements)
        }

        // Iframes
        const $iframes = this.el.querySelectorAll('iframe')
        this.setIframes($iframes)

        // Images
        setTimeout(() => {
            const $images = this.el.querySelectorAll('img')
            if ($images.length) {
                let imagesObjArr = this.clearImagesSrc($images)
                imagesObjArr = this.setImagesSrcSizes(imagesObjArr)
                this.replaceImage(imagesObjArr)
            }
        }, 200)
    }

    /////////////////
    // Iframes
    /////////////////
    setIframes(iframes) {
        if (!iframes.length) return

        let index = 0
        while (index < iframes.length) {
            const $iframe = iframes[index]
            const $parent = queryClosestParent($iframe, 'p') || queryClosestParent($iframe, 'center')

            if($parent && $parent.classList) {
                $parent.classList.add("c-wysiwyg_iframe")
            }

            index++
        }
    }

    /////////////////
    // Images
    /////////////////
    clearImagesSrc(images) {
        if (!images.length) return []

        const imagesArr = []

        let index = 0
        while(index < images.length) {
            const $image = images[index]

            const imageUrl = $image.src.toString()
            const regex = /_\d{1,4}x\d{1,4}/g
            const hasSizeInUrl = regex.exec(imageUrl)

            if (hasSizeInUrl) {
                imagesArr.push({
                    image: $image,
                    src: imageUrl.split(regex).join('')
                })
            } else {
                imagesArr.push({
                    image: $image,
                    src: imageUrl
                })
            }

            index++
        }

        return imagesArr
    }

    setImagesSrcSizes(imagesObjArr) {
        if (!imagesObjArr.length) return
        
        let index = 0
        while (index < imagesObjArr.length) {
            const $image = imagesObjArr[index].image

            const width = $image.naturalWidth
            const height = $image.naturalHeight

            if (width >= height) {
                imagesObjArr[index].src = this.getResizedImageUrl(imagesObjArr[index].src, LANDSCAPE_WIDTH, LANDSCAPE_HEIGHT)
                imagesObjArr[index].modifier = "-landscape"
            } else {
                imagesObjArr[index].src = this.getResizedImageUrl(imagesObjArr[index].src, PORTRAIT_WIDTH, PORTRAIT_HEIGHT)
                imagesObjArr[index].modifier = "-portrait"
            }
            index++
        }

        return imagesObjArr
    }

    replaceImage(imagesObjArr) {
        if (!imagesObjArr.length) return
        
        let index = 0
        while (index < imagesObjArr.length) {
            const imageObj = imagesObjArr[index]
            loadImage(imageObj.src).then(newImage => {
                requestAnimationFrame(() => {
                    imageObj.image.setAttribute('src', newImage.url)
                    const $parent = queryClosestParent(imageObj.image, 'p')
                    $parent.classList.add("c-wysiwyg_image")
                    $parent.classList.add(imageObj.modifier)
                })
            })
            index++
        }

        return imagesObjArr
    }

    getResizedImageUrl(imageUrl, width, height) {
        const splitUrl = imageUrl.split('.')
        const sizeExtension = `_${width}x${height}_crop_center.${splitUrl.pop()}`
        return splitUrl.join('.') + sizeExtension
    }

    destroy() {
        super.destroy();
    }
}
